import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import { Link } from '@bd/bdcore-named-routes';
import { css } from '@bd/bdui-styles/emotion';
import { colors, typography } from '../../../styles';

const styles = css`
  width: 100%;
  padding: 10px 0 20px 0;
  background-color: ${colors.neutral};
  background-position: center center;
  background-size: cover;
  @media(min-width: 992px) {
    display: none;
  }
  .CTA_wrapper {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
  .CTA_content {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: flex-start;
    width: 100%;
  }
  .CTA_button {
    width: 50%;
    height: 150px;
    position: relative;
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-family: ${typography.Condensed};
    font-weight: 700;
    color: ${colors.body};
    font-size: 29px;
  }
  .CTA_buttonImage {
    height: 50px;
    width: auto;
    margin: 0 0 10px 0;
  }
  .CTA_buttonTitle {
    position: relative;
    z-index: 2;
    font-size: 18px;
    line-height: 1.2;
    color: ${colors.body};
    font-family: ${typography.Serif};
    font-weight: 600;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
  }
  .CTA_buttonCount {
    display: flex;
    justify-content: center;
    align-items: center;
    color: ${colors.white};
    font-family: ${typography.Serif};
    font-size: 48px;
    line-height: .75;
  }
`;


function CtaBanner({ content, communities, homes, plans }) {
  return (
    <div className={styles}>
      <div className="container">
        <div className="CTA_wrapper">
          <div className="CTA_content">
            {
              get(content, '[0].cta_items', []).map(item => (
                <Link
                  name={get(item, 'route')}
                  className="CTA_button"
                  key={get(item, 'title_line_1')}
                >
                  <img className="CTA_buttonImage" src={get(item, 'image.contentUrl')} alt="" />
                  <div className="CTA_buttonTitle">
                    {
                      get(item, 'route') === 'communities' &&
                      get(item, 'show_count_for_properties') &&
                      <div className="CTA_buttonCount">{communities.length}</div>
                    }
                    {
                      get(item, 'route') === 'homes' &&
                      get(item, 'show_count_for_properties') &&
                      <div className="CTA_buttonCount">{homes.length}</div>
                    }
                    {
                      get(item, 'route') === 'plans' &&
                      get(item, 'show_count_for_properties') &&
                      <div className="CTA_buttonCount">{plans.length}</div>
                    }
                    <div>{get(item, 'title_line_1')}</div>
                    <div>{get(item, 'title_line_2')}</div>
                  </div>
                </Link>
              ))
            }
          </div>
        </div>
      </div>
    </div>
  );
}


CtaBanner.propTypes = {
  content: PropTypes.arrayOf(PropTypes.object).isRequired,
  communities: PropTypes.arrayOf(PropTypes.object).isRequired,
  homes: PropTypes.arrayOf(PropTypes.object).isRequired,
  plans: PropTypes.arrayOf(PropTypes.object).isRequired,
};

CtaBanner.defaultProps = {
};

export default withData({
  communities: 'all',
  homes: 'all',
  plans: 'all',
},
  {
    isRequired: {
      communities: true,
      homes: true,
      plans: true,
    },
  },
)(CtaBanner);



// WEBPACK FOOTER //
// ./src/components/PageLoader/Sections/CTABannerIcons.section.js